module.exports = __webpack_public_path__ + "img/brand(9).b3dbceb0.png";